import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

export const ContentTypeCreate = () => (
  <Create title="Create content type" redirect="list">
    <SimpleForm>
      <TextInput source="name" label="Name" required />
      <TextInput source="display_name" label="Display Name" required />
      <TextInput source="description" label="Description" />
    </SimpleForm>
  </Create>
);

